import React from 'react';
import { AxiosError } from 'axios';

import { useMicrosoft } from '../_libs/hooks/useMicrosoft';
import { UserType } from '../_libs/microsoft/types';

const MicrosoftSSOWidget = ({
  error,
  type,
}: {
  error: AxiosError;
  type: UserType;
}): JSX.Element => {
  const {
    handleSSO
  } = useMicrosoft();
  return (
    <div>
      <h2 className="f-serif f-normal">Please verify your Microsoft account to continue</h2>
      <button type="button" onClick={ () => { handleSSO(type); } }>Microsoft Single Sign-On</button>
      {error?.message}
    </div>
  );
};

export default MicrosoftSSOWidget;
